export class DryDocking {
    constructor(
        plannedDate: Date | null,
        type: string | null,
        days: number | null,
        yardArea: string | null,
        bsDueDate: Date | null,
        bwtsDueDate: Date | null,
        comments: string | null,
        dataSource: string | null
    ) {
        this.plannedDate = plannedDate;
        this.type = type;
        this.days = days;
        this.yardArea = yardArea;
        this.bsDueDate = bsDueDate;
        this.bwtsDueDate = bwtsDueDate;
        this.comments = comments;
        this.dataSource = dataSource;
    }
    plannedDate: Date | null;
    type: string | null;
    days: number | null;
    yardArea: string | null;
    bsDueDate: Date | null;
    bwtsDueDate: Date | null;
    comments: string | null;
    dataSource: string | null;
}
